export default "__VITE_ASSET__BV1J$$zK__"